import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PlaysNumber } from 'components/plays-number';

export const MetadataPlays = ({ plays, isItem }) => {
  const { t } = useTranslation();
  if (isItem) {
    return (
      <span data-e2e="video-list-plays" className="ct-video-additional-metadata__list-elem">
        <PlaysNumber plays={plays} />
      </span>
    );
  } else {
    return (
      <span data-e2e="video-list-plays" className="ct-video-additional-metadata__list-elem">
        {plays} {t('plays')}
      </span>
    );
  }
};

MetadataPlays.propTypes = {
  plays: PropTypes.number.isRequired,
  isItem: PropTypes.bool,
};
